/**
 * Channel URL encoding/decoding utilities
 *
 * Provides base64url encoding for SendBird channel URLs to create
 * shareable, bookmarkable browser URLs.
 */

/**
 * Encode SendBird channelUrl for use in browser URLs
 * Uses base64url encoding (URL-safe, reversible)
 *
 * @param {string} channelUrl - The SendBird channel URL
 * @returns {string|null} - Base64url-encoded string, or null if input is falsy
 */
export const encodeChannelId = (channelUrl) => {
  if (!channelUrl) return null;
  return btoa(channelUrl)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

/**
 * Decode browser URL back to SendBird channelUrl
 *
 * @param {string} channelId - The base64url-encoded channel ID from URL
 * @returns {string|null} - Decoded channel URL, or null if decoding fails
 */
export const decodeChannelId = (channelId) => {
  if (!channelId) return null;
  try {
    // Restore base64 padding and characters
    let base64 = channelId.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    return atob(base64);
  } catch (e) {
    console.error('Failed to decode channelId:', e);
    return null;
  }
};
